import { useCallback, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useDispatch } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import PaginationRow from 'components/atoms/GefMui/PaginationRow';
import fetch from 'features/common/fetch';
import {
	fetchMyTeamSummary,
	loadMoreMyTeam,
	loadPageMyTeam,
	reloadMyTeam,
} from 'features/views/dashboard/statistics/actions';

import MyTeamTableBody from './MyTeamTableBody';

export const MyTeamTable = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchMyTeamSummary());
	}, [dispatch]);

	const handleLoadMore = useCallback(() => {
		dispatch(loadMoreMyTeam());
	}, [dispatch]);

	const handlePaginationClick = useCallback(
		(e, page) => {
			dispatch(loadPageMyTeam(page - 1));
		},
		[dispatch],
	);

	const handleReload = useCallback(() => {
		dispatch(reloadMyTeam());
	}, [dispatch]);

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.myTeamSummary} onReload={handleReload} forceInlineError>
			<Paper sx={{ p: 3, backgroundColor: (theme) => theme.palette.background[100], borderRadius: 1 }}>
				<Paper sx={{ borderRadius: 2 }}>
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell sx={{ width: '50px' }} />
								<TableCell>{getMessage('dashboard:statistics.seller')}</TableCell>
								<TableCell>
									<div>{getMessage('dashboard:statistics.tasks')}</div>
									<div>{getMessage('dashboard:statistics.tasksSubTitle')}</div>
								</TableCell>
								<TableCell>
									<div>{getMessage('dashboard:statistics.leads')}</div>
									<div>{getMessage('dashboard:statistics.leadsSubTitle')}</div>
								</TableCell>
								<TableCell>
									<div>{getMessage('dashboard:statistics.contacts')}</div>
									<div>{getMessage('dashboard:statistics.contactsSubTitle')}</div>
								</TableCell>
							</TableRow>
						</TableHead>
						<MyTeamTableBody />
						<PaginationRow
							colSpan={100}
							fetchStorePath={fetch.constants.urls.myTeamSummary}
							onLoadNext={handleLoadMore}
							onPaginationClick={handlePaginationClick}
						/>
					</Table>
				</Paper>
			</Paper>
		</ComponentLoader>
	);
};

export default MyTeamTable;
